document.addEventListener('DOMContentLoaded', function () {
  var symbols = [
    '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#F5D76E" stroke-width="2"><circle cx="12" cy="12" r="10"/><path d="M8 12h8"/><path d="M12 8v8"/></svg>',
    '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#60b5f0" stroke-width="2"><path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"/></svg>',
    '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#f5a623" stroke-width="2"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="4"/></svg>',
    '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#e05080" stroke-width="2"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>',
    '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#4aba70" stroke-width="2"><path d="M11 20A7 7 0 0 1 9.8 6.9C15.5 4.9 17 3.5 19 2c1 2 2 4.5 2 8 0 5.5-4.78 10-10 10z"/><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/></svg>',
    '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#f5d76e" stroke-width="2"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>',
    '<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="#d070d0" stroke-width="2"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/></svg>'
  ];

  var symbolIds = ['plus', 'drop', 'sun', 'heart', 'leaf', 'bolt', 'shield'];
  var prizes = [
    { match: 'plus,plus,plus', text: '%20 Indirim!', code: 'SAOL20' },
    { match: 'drop,drop,drop', text: 'Ucretsiz Kargo!', code: 'KARGO' },
    { match: 'sun,sun,sun', text: '1 Sise Hediye!', code: 'HEDIYE' },
    { match: 'heart,heart,heart', text: '%15 Indirim!', code: 'SAOL15' },
    { match: 'leaf,leaf,leaf', text: '%10 Indirim!', code: 'SAOL10' },
    { match: 'bolt,bolt,bolt', text: '%25 Indirim!', code: 'SAOL25' },
    { match: 'shield,shield,shield', text: 'Surpriz Hediye!', code: 'SURPRIZ' }
  ];
  var REEL_COUNT = 28;
  var spinsLeft = 3;
  var spinning = false;

  var trigger = document.createElement('button');
  trigger.className = 'sj-trigger';
  trigger.setAttribute('aria-label', 'Jackpot');
  trigger.innerHTML = '<span><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#1a1a1a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="4" width="20" height="16" rx="2"/><path d="M12 4v16"/><path d="M2 12h20"/><circle cx="7" cy="8" r="1.5" fill="#1a1a1a" stroke="none"/><circle cx="17" cy="8" r="1.5" fill="#1a1a1a" stroke="none"/><circle cx="7" cy="16" r="1.5" fill="#1a1a1a" stroke="none"/><circle cx="17" cy="16" r="1.5" fill="#1a1a1a" stroke="none"/></svg></span>';
  document.body.appendChild(trigger);

  var overlay = document.createElement('div');
  overlay.className = 'sj-overlay';
  overlay.innerHTML =
    '<div class="sj-modal">' +
      '<button class="sj-close">&times;</button>' +
      '<h2>SAOL Jackpot</h2>' +
      '<p>3 ayni sembolu yakala, odulu kap!</p>' +
      '<div class="sj-machine">' +
        '<div class="sj-reel"><div class="sj-strip r1" id="sj-r1"></div></div>' +
        '<div class="sj-reel"><div class="sj-strip r2" id="sj-r2"></div></div>' +
        '<div class="sj-reel"><div class="sj-strip r3" id="sj-r3"></div></div>' +
      '</div>' +
      '<button class="sj-spin" id="sj-spin">CEK!</button>' +
      '<div class="sj-result-msg" id="sj-msg"></div>' +
      '<div class="sj-result-sub" id="sj-sub"></div>' +
      '<div class="sj-lives" id="sj-lives"></div>' +
    '</div>';
  document.body.appendChild(overlay);

  function randIdx() { return Math.floor(Math.random() * symbols.length); }

  function buildStrip(reelId, count) {
    var el = document.getElementById(reelId);
    el.innerHTML = '';
    for (var i = 0; i < count; i++) {
      var s = document.createElement('div');
      s.className = 'sj-symbol';
      var idx = randIdx();
      s.innerHTML = symbols[idx];
      s.dataset.sid = symbolIds[idx];
      el.appendChild(s);
    }
    return el;
  }

  function setSymbolAt(reelId, idx, symIdx) {
    var el = document.getElementById(reelId);
    if (el.children[idx]) {
      el.children[idx].innerHTML = symbols[symIdx];
      el.children[idx].dataset.sid = symbolIds[symIdx];
    }
  }

  function initReels() {
    buildStrip('sj-r1', REEL_COUNT);
    buildStrip('sj-r2', REEL_COUNT);
    buildStrip('sj-r3', REEL_COUNT);
    ['sj-r1','sj-r2','sj-r3'].forEach(function(id) {
      var el = document.getElementById(id);
      el.style.transition = 'none';
      el.style.transform = 'translateY(0)';
    });
    updateLives();
  }

  function updateLives() {
    document.getElementById('sj-lives').textContent = spinsLeft > 0
      ? 'Kalan hak: ' + spinsLeft
      : '';
  }

  function spin() {
    if (spinning || spinsLeft <= 0) return;
    spinning = true;
    spinsLeft--;
    var btn = document.getElementById('sj-spin');
    btn.disabled = true;
    document.getElementById('sj-msg').style.display = 'none';
    document.getElementById('sj-sub').style.display = 'none';

    var winChance = Math.random();
    var isWin = winChance < 0.35;
    var resultIdx = [];

    if (isWin) {
      var winIdx = randIdx();
      resultIdx = [winIdx, winIdx, winIdx];
    } else {
      resultIdx[0] = randIdx();
      resultIdx[1] = randIdx();
      do { resultIdx[2] = randIdx(); }
      while (resultIdx[0] === resultIdx[1] && resultIdx[1] === resultIdx[2]);
    }

    var stopPositions = [REEL_COUNT - 3, REEL_COUNT - 3, REEL_COUNT - 3];
    for (var r = 0; r < 3; r++) {
      setSymbolAt(['sj-r1','sj-r2','sj-r3'][r], stopPositions[r], resultIdx[r]);
    }

    var reelIds = ['sj-r1','sj-r2','sj-r3'];
    reelIds.forEach(function(id, i) {
      var el = document.getElementById(id);
      el.style.transition = 'none';
      el.style.transform = 'translateY(0)';
      void el.offsetHeight;
      var offset = stopPositions[i] * 90;
      el.style.transition = 'transform ' + (2 + i * 0.4) + 's cubic-bezier(.25,.1,.25,1)';
      el.style.transform = 'translateY(-' + offset + 'px)';
    });

    setTimeout(function () {
      spinning = false;
      var matchStr = resultIdx.map(function(i) { return symbolIds[i]; }).join(',');
      var prize = prizes.find(function(p) { return p.match === matchStr; });
      var msg = document.getElementById('sj-msg');
      var sub = document.getElementById('sj-sub');

      if (prize) {
        msg.textContent = prize.text;
        msg.style.display = 'block';
        sub.innerHTML = 'Indirim kodun: <strong>' + prize.code + '</strong> — Sepette kullan!';
        sub.style.display = 'block';
      } else {
        msg.textContent = 'Az kaldi! Tekrar dene.';
        msg.style.display = 'block';
        if (spinsLeft > 0) {
          sub.textContent = 'Tekrar dene, sansini zorla!';
          sub.style.display = 'block';
        } else {
          sub.textContent = 'Haklarin bitti. Yarin tekrar gel!';
          sub.style.display = 'block';
        }
      }

      updateLives();
      if (spinsLeft > 0 && !prize) {
        btn.disabled = false;
        setTimeout(function() { initReels(); }, 600);
      }
    }, 3200);
  }

  initReels();

  trigger.addEventListener('click', function () { overlay.classList.add('open'); });
  overlay.querySelector('.sj-close').addEventListener('click', function () { overlay.classList.remove('open'); });
  overlay.addEventListener('click', function (e) { if (e.target === overlay) overlay.classList.remove('open'); });
  document.getElementById('sj-spin').addEventListener('click', spin);
});
